module.exports = __webpack_public_path__ + "static/img/banner-bg.7bfeae88.png";